'use strict';

window.MPP = {};
